import React from "react";

import { FaShoppingCart } from "react-icons/fa"; // Example Icon (can be any from react-icons)

const CardComponent = ({ title, count, link, totalLead, percentage }) => {
  return (
    <div className="card-container">
      {/* <div> */}
      <div className="card-body">
        <div className="d-flex align-items-center justify-content-between">
          <div className="flex-grow-1 overflow-hidden mx-2">
            <p className="text-uppercase fw-medium text-muted text-truncate mb-0">
              {title}
            </p>
          </div>
          <div className="flex-shrink-0 mx-2">
            <h5 className="text-success fs-14 mb-0">
              <i className="ri-arrow-right-up-line fs-13 align-middle"></i>{" "}
              {percentage ? `${percentage} %` : ""}
            </h5>
          </div>
        </div>

        <div className="d-flex align-items-end justify-content-between mt-3">
          <div>
            <h4 className="fs-22 fw-semibold ff-secondary mb-3">
              <span className="counter-value" data-target="559.25">
                {count}
              </span>
            </h4>
          </div>
          <div>
            <span
              className="avatar-title rounded fs-2 p-2"
              style={{ backgroundColor: "#FFF4B5" }}
            >
              <FaShoppingCart color="#D91656" />
            </span>
          </div>
        </div>
      </div>
      {/* </div> */}
    </div>
  );
};

export default CardComponent;
